import React from "react";
import { DocumentsTab } from "./DocumentsTab";
import { Tabs } from "@shared/ui/tabs";
import { ContractTab } from "./ContractTab";

const DocumentLandingTab = ({
  consumerId,
  consumerNo,
  remoteUtilityId,
  subCategory,
  contractData,
}: {
  consumerId?: string;
  consumerNo?: string;
  remoteUtilityId?: number;
  subCategory?: string;
  contractData?: any;
}) => {
  const urlMapping = {
    consumerDocuments: "consumerDocuments",
    contracts: "contracts",
  };
  const tabComponents = {
    consumerDocuments: {
      label: "Consumer Documents",
      component: (
        <DocumentsTab
          consumerId={consumerId}
          consumerNo={consumerNo}
          remoteUtilityId={Number(remoteUtilityId)}
        />
      ),
    },
    contracts: {
      label: "Contracts",
      component: (
        <ContractTab
          contractData={contractData}
          consumerId={consumerId}
          consumerNo={consumerNo}
          remoteUtilityId={Number(remoteUtilityId)}
          subCategory={subCategory}
        />
      ),
    },
  };
  return (
    <div className="space-y-6">
      {/* Tabs Section */}
      <Tabs
        defaultValue="consumerDocuments"
        className="w-full"
        tabsListClassName="grid grid-cols-2 w-full bg-gradient-to-r from-blue-100/50 to-indigo-100/50 shadow-sm"
        urlMapping={urlMapping}
        tabComponents={tabComponents}
        level={1} // Top-level tabs
      />
    </div>
  );
};

export default DocumentLandingTab;
